import { Controller } from "@hotwired/stimulus"

import {
  Chart,
  BarController,
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend
} from "chart.js"

// Registrando explicitamente apenas o que será usado (padrão igual ao seu)
Chart.register(
  BarController,
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend
)

export default class extends Controller {
  static values = {
    data: Object,     // { labels: [...], datasets: [...] }
    options: Object   // { ... }
  }

  connect() {
    // Chart precisa que o <canvas> tenha altura (dada pelo container)
    const ctx = this.element.getContext("2d")

    this.chart = new Chart(ctx, {
      type: "bar",
      data: this.dataValue,
      options: {
        responsive: true,
        maintainAspectRatio: false, // respeita altura do container
        ...this.optionsValue
      }
    })
  }

  // Atualizações reativas se você trocar os data-* no HTML
  dataValueChanged(value) {
    if (!this.chart) return
    this.chart.data = value
    this.chart.update()
  }

  optionsValueChanged(value) {
    if (!this.chart) return
    this.chart.options = {
      responsive: true,
      maintainAspectRatio: false,
      ...value
    }
    this.chart.update()
  }

  // Listener opcional para evento customizado
  // bar-chart#onUpdate
  onUpdate(event) {
    const { labels, datasets, options } = event.detail || {}
    if (labels) this.chart.data.labels = labels
    if (datasets) this.chart.data.datasets = datasets
    if (options) this.chart.options = { ...this.chart.options, ...options }
    this.chart.update()
  }

  disconnect() {
    this.chart?.destroy()
    this.chart = null
  }
}

